import { render, staticRenderFns } from "./ProjectManagementModal.vue?vue&type=template&id=e6b53786&v-on-clickaway=cancel&"
import script from "./ProjectManagementModal.vue?vue&type=script&lang=ts&"
export * from "./ProjectManagementModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports